export enum OperationStatus {
  Active = 'Active', // Posted, waiting
  Error = 'Error', // Error from HFS action
  Timeout = 'Timeout', // Timeout from HFS action
  Done = 'Done', // Done from HFS action
  Completed = 'Completed', // Completed from HFS action
  Acknowledged = 'Acknowledged', // Completed from HFS action
  Failed = 'Failed', // Failure delivered using other channel
  Sent = 'Sent', // Failure delivered using other channel
  Success = 'Success', // Success delivered using other channel
  Posting = 'Posting', // Sending POST to BFF endpoint
  Rejected = 'Rejected', // Rejected by BFF endpoint
}
